import * as firebase from "firebase/app";
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/performance'
import '@firebase/analytics'
import '@firebase/messaging'

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: process.env.VUE_APP_FB_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: "197004799670",
  appId: process.env.VUE_APP_APP_ID,
  measurementId: 'G-F25Z93VM1Z',
};
// Initialize Firebase

!firebase.apps.length ? firebase.initializeApp(firebaseConfig) : ''

// enable oflline persistence and cache
firebase.firestore().enablePersistence()

// TODO: delete on prod
// firebase.functions().useFunctionsEmulator('http://localhost:5000')


export const db = firebase.firestore();
export const storage = firebase.storage();
export const fbFunctions = firebase.app().functions('europe-west1');
export const fsTimestamp = firebase.firestore.Timestamp

// Get the Analytics service for the default app
export const analytics = firebase.analytics();
// analytics.logEvent('notification_received');

// Initialize Performance Monitoring and get a reference to the service
export const perf = firebase.performance();

firebase.auth().useDeviceLanguage();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
// export const fbProvider = new firebase.auth.FacebookAuthProvider();
export const auth = firebase.auth();

export function eventRefs(eventID) {
  return {
    eventDataDoc: { ref: db.doc(`events/${eventID}`) },
    eventSuperSettingsDoc: { ref: db.doc(`events/${eventID}/event-super/super-settings`) },
    eventDetailsInfoDoc: { ref: db.doc(`events/${eventID}/event-details/event-info`) },
    eventTicketInfoDoc: { ref: db.doc(`events/${eventID}/event-tickets/ticket-info`) },
  }
}


// Cloud Messaging (Push Notifications)
export const messaging = firebase.messaging();
messaging.usePublicVapidKey("BGohh3qCrPc-kSAQqPIrdH3WkOJbIa0lCt7kdJAoBnbyRAKdP_V750zfDZf7BbZNibM9OlSw3WClhg4NPQAyoVg");
// messaging.onMessage(payload => {
//   console.log("onMessage :", payload);
// });
// messaging.getToken().then(token => console.log('TOKENNN', token))

messaging.onTokenRefresh(() => {
  messaging.getToken().then((refreshedToken) => {
    console.log('Token refreshed.', refreshedToken);
    // Indicate that the new Instance ID token has not yet been sent to the
    // app server.
    // setTokenSentToServer(false);
    // Send Instance ID token to app server.
    // sendTokenToServer(refreshedToken);
    // ...
  }).catch((err) => {
    console.log('Unable to retrieve refreshed token ', err);
    // showToken('Unable to retrieve refreshed token ', err);
  });
});